import { PropsWithChildren } from "react";

export const ToggleSwitch = ({
    dataTestId,
    labelText,
    value,
    onChangeAction
}: PropsWithChildren<{
    dataTestId?: string;
    labelText: string;
    value: boolean;
    onChangeAction: () => void;
}>) => {
    return (
        <label className="flex w-full cursor-pointer items-center justify-between">
            <span className="text-sm font-medium text-gray-700">
                {labelText}
            </span>

            <input
                data-testid={dataTestId + "-input"}
                type="checkbox"
                className="sr-only"
                checked={value}
                onChange={onChangeAction}
            />
            <div
                data-testid={dataTestId}
                className={`relative h-6 w-11 rounded-full transition-colors ${
                    value ? "bg-primary-600" : "bg-gray-200"
                }`}
            >
                <span
                    className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-all${
                        value ? "translate-x-5" : ""
                    }`}
                />
            </div>
        </label>
    );
};
